// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".modal-box[data-v-0733ed3f] {\n  height: 100%;\n  overflow: hidden;\n}\n.modal-body[data-v-0733ed3f] {\n  height: calc(100% - 52px - 10px);\n  overflow: hidden;\n  position: relative;\n  margin-left: 16px;\n  margin-right: 16px;\n}\n.modal-body .tree-section[data-v-0733ed3f] {\n  height: calc(100% - 40px);\n  overflow: auto;\n}", ""]);
// Exports
module.exports = exports;
